import './Trainers.css';
import { useEffect } from 'react';

function Trainers() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="trainers-page">
      {/* Header Space */}
      <div className="header-spacer"></div>

      {/* Hero Section */}
      <section className="trainers-hero">
        <div className="hero-shapes">
          <div className="shape-circle shape-1"></div>
          <div className="shape-circle shape-2"></div>
          <div className="shape-circle shape-3"></div>
        </div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-badge-wrapper">
              <span className="hero-badge">⭐ فريق متميز</span>
            </div>
            <h1 className="trainers-main-title">أعضاء هيئة التدريس</h1>
            <div className="title-decoration"></div>
            <p className="trainers-description">
              نفخر بالمدربين والمستشارين أصحاب الخبرة الواسعة<br/>
              في مجالات متعددة، والذين يستخدمون أساليب تدريبية حديثة
            </p>
          </div>
        </div>
      </section>

      {/* Trainers Section */}
      <section className="trainers-section">
        <div className="container">

          <div className="trainers-grid">
            {/* Trainer 1 */}
            <div className="trainer-card">
              <div className="trainer-image">
                <img src="/dr.talaat.jpg" alt="د. طلعت آدم" />
                <div className="trainer-overlay"></div>
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name">د. طلعت آدم</h3>
                <p className="trainer-title">استاذ الدراسات العليا</p>
                <p className="trainer-specialty">المدير العام</p>
              </div>
            </div>

            {/* Trainer 2 */}
            <div className="trainer-card">
              <div className="trainer-image">
                <img src="/zon.jpg" alt="أ. زينب عبدالله" />
                <div className="trainer-overlay"></div>
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name">أ. زينب عبدالله</h3>
                <p className="trainer-title">مدرب TOT</p>
                <p className="trainer-specialty">المدير التنفيذي</p>
              </div>
            </div>

            {/* Trainer 3 */}
            <div className="trainer-card">
              <div className="trainer-image">
                <img src="/suliman.jpg" alt="د. سليمان محمد الكعبي" />
                <div className="trainer-overlay"></div>
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name">د. سليمان محمد الكعبي</h3>
                <p className="trainer-title">خبير تقنيات استشراف المستقبل</p>
              </div>
            </div>

            {/* Trainer 4 */}
            <div className="trainer-card">
              <div className="trainer-image">
                <img src="/d.jpg" alt="د دعاء عبد الراضي" />
                <div className="trainer-overlay"></div>
              </div>
              <div className="trainer-info">
                <h3 className="trainer-name">د دعاء عبد الراضي</h3>
                <p className="trainer-title">المنسق العام</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Trainers;
